import { makeObservable, action } from "mobx";
import { Voucher } from '../api';

export default class VoucherStore {
  constructor(rootStore) {
    this.rootStore = rootStore;
    makeObservable(this, {
      getVouchers: action
    });
  }

  async getVouchers() {
    let retObj = await Voucher.getVouchers();
    return retObj.data.response.vouchers;
  }
}